import { render, staticRenderFns } from "./GreyListPage.vue?vue&type=template&id=03cbec64"
import script from "./GreyListPage.vue?vue&type=script&lang=js"
export * from "./GreyListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports